
export const PartyNews = {
  data () {
    return {
      currentPage: 1,
      limitPage: 15,
      total: 0,
      newList: [],
      loading: true
    }
  },
  created: function () {
    this.getAllNews();
  },
  watch: {

  },
  methods: {
    itemRender (current) {
      this.currentPage = current;
      this.getAllNews();
    },
    // 点击新闻列表
    bindNewsItem (index) {
      this.newList[index].isClick = true
      this.$router.push({
        name: 'PartyNewsDetail',
        params: {
          articleId: this.newList[index].article_id
        }
      })
      // this.$router.push('/main/partynewsdetail')
    },
    // 获取党建新闻列表
    getAllNews () {
      // console.log(this.$store.state.isLogin);
      this.loading = true;
      var pageStart = (this.currentPage - 1) * this.limitPage;
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api&a=article_list_api&is_web=1&classify_id=3&page_start=' + pageStart + '&page_end=' + this.limitPage).then(function (response) {
        if (response.body.status == 1 && response.body.data != '') {
          this.newList = response.body.data.article_list;
          // console.log(response.body.data.page.sum_data_num)
          this.total = parseInt(response.body.data.page.sum_data_num);
        }
        this.loading = false;
      }, function (reserror) {
        console.log(reserror);
      })
    }

  }
}
